import React from "react";

const Hospital = () => {
  return (
    <div className="min-h-screen bg-slate-50 px-4 py-8 md:px-8">
      <div className="mx-auto max-w-6xl rounded-2xl bg-white shadow-lg overflow-hidden">
        <div className="bg-teal-700 p-6 md:p-8">
          <h1 className="text-3xl md:text-4xl font-bold text-white">Hospital Management Software</h1>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4">
          <aside className="bg-teal-800 p-6 text-white lg:min-h-[420px]">
            <ul className="space-y-4 text-sm md:text-base">
              <li>Patient Records</li>
              <li>Appointments</li>
              <li>Billing Support</li>
              <li>Operations Dashboard</li>
            </ul>
          </aside>

          <div className="lg:col-span-3 p-6 md:p-8">
            <h2 className="text-2xl md:text-3xl font-bold text-teal-700 mb-4">
              Streamline hospital operations
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              We deliver hospital administration software that supports patient info,
              scheduling, billing, and operational visibility in one secure platform.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="rounded-xl bg-slate-100 p-5">
                <h3 className="font-bold text-lg mb-2">Patient Management</h3>
                <p className="text-slate-600 text-sm">Maintain clean records and quick access to patient details.</p>
              </div>
              <div className="rounded-xl bg-slate-100 p-5">
                <h3 className="font-bold text-lg mb-2">Appointments</h3>
                <p className="text-slate-600 text-sm">Coordinate visits and reduce manual scheduling issues.</p>
              </div>
              <div className="rounded-xl bg-slate-100 p-5">
                <h3 className="font-bold text-lg mb-2">Dashboard Insight</h3>
                <p className="text-slate-600 text-sm">Monitor operational performance and daily service flow.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hospital;
